//LOGIN
export const DATOS_LOGIN = 'DATOS_LOGIN';
export const ENVIAR_LOGIN = 'ENVIAR_LOGIN';
export const ALERTA_USUARIO = 'ALERTA_USUARIO';
export const ALERTA_USUARIO_STR = 'ALERTA_USUARIO_STR';

//RECUPERAR CLAVE
export const CORREO_RECUPERAR = 'CORREO_RECUPERAR';
export const ENVIAR_RECUPERAR = 'ENVIAR_RECUPERAR';
export const ALERTA_RECUPERAR = 'ALERTA_RECUPERAR';
export const ALERTA_RECUPERAR_STR = 'ALERTA_RECUPERAR_STR';

//MODIFICAR CLAVE
export const DATOS_MODIFICAR = 'DATOS_MODIFICAR';
export const ENVIAR_MODIFICAR = 'ENVIAR_MODIFICAR';
export const ALERTA_MODIFICAR = 'ALERTA_MODIFICAR';
export const ALERTA_MODIFICAR_STR = 'ALERTA_MODIFICAR_STR';
export const ALERTA_MODIFICAR_CLASS = 'ALERTA_MODIFICAR_CLASS';


//PRESTADOR
export const CONSULTAR_API_PRESTADORES = 'CONSULTAR_API_PRESTADORES';
export const JSON_RESPUESTA_API = 'JSON_RESPUESTA_API';
export const DATOS_METODO_PRESTADOR = 'DATOS_METODO_PRESTADOR';
export const RESPUESTA_API_PRESTADORES = 'RESPUESTA_API_PRESTADORES';
